import { Reducer } from 'redux'
import { createSelector } from 'reselect'
import { IMarketplaceStore } from 'apps/marketplace/store/types'
import { SHIPMENT_ACTION_TYPES as c, AUCTION_SHIPMENT_ACTION_TYPES as d } from './actions'
import { IShipmentState, IShipment } from './types'

const defaultState = {
  data: undefined,
  loading: false,
  error: '',
}

type ShipmentActions =
  | { type: c.FETCH_SHIPMENT_REQUEST }
  | { type: d.FETCH_AUCTION_SHIPMENT_REQUEST }
  | { type: c.FETCH_SHIPMENT_SUCCESS; payload: { shipment: IShipment } }
  | { type: d.FETCH_AUCTION_SHIPMENT_SUCCESS; payload: { shipmentInfo: IShipment } }
  | { type: c.FETCH_SHIPMENT_FAILURE; error: string }
  | { type: d.FETCH_AUCTION_SHIPMENT_FAILURE; error: string }

const shipmentReducer: Reducer<IShipmentState, ShipmentActions> = (
  state: IShipmentState = defaultState,
  action: ShipmentActions
): IShipmentState => {
  switch (action.type) {
    case c.FETCH_SHIPMENT_REQUEST:
    case d.FETCH_AUCTION_SHIPMENT_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case c.FETCH_SHIPMENT_SUCCESS: {
      const { shipment: data } = action.payload
      return {
        ...state,
        data,
      }
    }
    case d.FETCH_AUCTION_SHIPMENT_SUCCESS: {
      const { shipmentInfo: data } = action.payload
      return {
        ...state,
        data,
      }
    }
    case c.FETCH_SHIPMENT_FAILURE:
    case d.FETCH_AUCTION_SHIPMENT_FAILURE: {
      const { error } = action
      return {
        ...state,
        error,
      }
    }
    default:
      return state
  }
}

export default shipmentReducer

export const selectShipment = (state: IMarketplaceStore): IShipment | undefined =>
  state.shipment.data

export const selectDropTrailer = createSelector(selectShipment, shipment =>
  (shipment?.stops || []).map(stop => stop?.isDropTrailer).includes(true)
)

export const selectFirstStopTime = createSelector(
  selectShipment,
  shipment => shipment?.stops[0]?.appointment?.startAt
)
